import React from 'react';
import moment from 'moment';
import URLUtils from '../../util/URLUtils';
import {
    BlogCardLink,
    BlogCardThumbnail,
    BlogCardContent,
    BlogCardTitle,
    BlogCardSubTitle,
} from './style';

interface BlogCardProps {
    featuredImage: string;
    name: string;
    publishDate: string;
    id: string;
}

const BlogCard = ({ featuredImage, name, publishDate, id }: BlogCardProps) => {
    const redirectPath = `/blog/${id}/${URLUtils.formatEncodePath(name)}`;

    return (
        <BlogCardLink to={redirectPath}>
            <BlogCardThumbnail
                errorImg='/app-images/not-found-image/place_holder_image.png'
                src={featuredImage}
                alt={name}
            />
            <BlogCardContent>
                <BlogCardTitle>{name}</BlogCardTitle>
                <BlogCardSubTitle>{moment(publishDate).format('MMMM Do YYYY')}</BlogCardSubTitle>
            </BlogCardContent>
        </BlogCardLink>
    );
};

export default BlogCard;
